import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { isBusinessApiUrl } from '@zeusm/shared/core/helpers';
import { getPersistedActiveBusinessProfileId } from '@zeusm/shared/session/profile/helpers';

const BUSINESS_PROFILE_ID_HEADER = 'Business-Profile-Id';

/**
 * Adds active business profile id to business API requests
 */
@Injectable()
export class BusinessProfileInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!isBusinessApiUrl(request.url)) {
      return next.handle(request);
    }

    const activeBusinessProfileId = getPersistedActiveBusinessProfileId();
    if (!activeBusinessProfileId) {
      return next.handle(request);
    }

    const requestWithBusinessProfileId = request.clone({
      setHeaders: {
        [BUSINESS_PROFILE_ID_HEADER]: activeBusinessProfileId,
      },
    });

    return next.handle(requestWithBusinessProfileId);
  }
}
